import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  aspectRatio?: '16/9' | '4/3' | '1/1' | 'auto';
  fallback?: React.ReactNode;
}

export default function LazyImage({
  src,
  alt,
  className = '',
  aspectRatio = 'auto',
  fallback
}: LazyImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  const aspectRatioClasses = {
    '16/9': 'aspect-video',
    '4/3': 'aspect-4/3',
    '1/1': 'aspect-square',
    'auto': ''
  };

  if (error) {
    return (
      <div className={`bg-gray-100 flex items-center justify-center ${aspectRatioClasses[aspectRatio]} ${className}`}>
        {fallback || (
          <div className="text-center text-gray-400">
            <ImageOff className="h-8 w-8 mx-auto mb-2" />
            <span className="text-sm">Failed to load image</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`relative ${aspectRatioClasses[aspectRatio]} ${className}`}>
      {isLoading && (
        <div className="absolute inset-0 bg-gray-100 animate-pulse" />
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover transition-opacity duration-300 ${
          isLoading ? 'opacity-0' : 'opacity-100'
        }`}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          setError(true);
        }}
      />
    </div>
  );
}